var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('modal-template',_vm._b({on:{"close":function($event){return _vm.closeModal()}}},'modal-template',_vm.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }